import { render, staticRenderFns } from "./gdPassRegister.vue?vue&type=template&id=4deca4aa"
import script from "./gdPassRegister.vue?vue&type=script&lang=js"
export * from "./gdPassRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports